import styled from 'styled-components';

export const ButtonWrapper = styled.div`
  display: flex;
  width: 100%;
  button {
    margin-left: auto;
    margin-right: auto;
  }
`;
